import React, { useState, Fragment, useEffect, useContext } from 'react';
import { Grid, Breadcrumb } from 'semantic-ui-react';
import { ProjectsList } from './ProjectsList';
import { ProjectsSidebar } from './ProjectsSidebar';
import apiRequest from '../../../app/common/api/apiClient';
import { UserContext } from '../../../app/layout/App';

const Projets = () => {
  const { state } = useContext(UserContext);
  const role = state.user?.type_utilisateur;
  const [isLoading, setIsLoading] = useState(true);
  const [projects, setProjects] = useState([]);
  const [search, setSearch] = useState('');
  const [filterCategory, setFilterCategory] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');

  useEffect(() => {
    apiRequest('/api/cases')
      .then(async (res) => {
        const data = await res.json();
        setProjects(data.features || []);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setIsLoading(false);
      });
  }, []);

  const filteredProjects = () => {
    let result = [...projects];
    if (search !== '') {
      result = result.filter((project) =>
        project.properties.name &&
        project.properties.name.toLowerCase().includes(search.toLowerCase())
      );
    }
    return result;
  };

  return (
    <Fragment>
      <Grid>
        <Grid.Column width={16}>
          <Breadcrumb>
            <Breadcrumb.Section active>Conflict cases</Breadcrumb.Section>
          </Breadcrumb>
        </Grid.Column>
      </Grid>
      <Grid>
        <Grid.Column width={4}>
          <ProjectsSidebar
            setSearch={setSearch}
            setFilterCategory={setFilterCategory}
            setFilterStatus={setFilterStatus}
            filterCategory={filterCategory}
            filterStatus={filterStatus}
          />
        </Grid.Column>
        <Grid.Column width={12}>
          <ProjectsList projects={filteredProjects()} isLoading={isLoading} role={role} />
        </Grid.Column>
      </Grid>
    </Fragment>
  );
};

export default Projets;
